import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ViewValentine from './pages/ViewValentine';
import CreateValentine from './pages/CreateValentine';
import MyValentines from './pages/MyValentines';
import AdminDashboard from './pages/AdminDashboard';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-pink-50">
          <Navbar />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/valentine/:id" element={<ViewValentine />} />
              <Route
                path="/create"
                element={
                  <ProtectedRoute>
                    <CreateValentine />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-valentines"
                element={
                  <ProtectedRoute>
                    <MyValentines />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              />
            </Routes>
          </main>
          <Toaster position="top-right" />
        </div>
      </Router>
      <Analytics />
    </AuthProvider>
  );
}

export default App;
